import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import {
    ServiceTypeEnum,
    FieldTypeEnum,
    RiderVehicleTypeEnum,
    ScheduleTrainingStatusEnum,
    TrainingStatusEnum,
    VehicleStatusEnum,
    ApplicationSourceTypeEnum,
    CenterTrainingTypeEnum, RiderTransportationTypeEnum, VehicleBrandModel, VehicleModel, ColorTypeSelection,
    RiderVehicleType, RiderServiceTypeModel, XpressRiderStatus, XpressVehicleStatus,
    DenialReasonEnum, DENIAL_REASON_OPTIONS, RidesharingAppModel
} from 'app/models';
import { RiderService, AppDataService, XpressCenterService, VehicleBrandService } from 'app/services';
import { XpressDocumentTypeEnum } from '@shared/enums/xpress-document-type.enum';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Utils } from 'app/utils';
import moment from 'moment';
import { OwnershipTypeEnum } from 'app/enums/ownership-type.enum';
import { SignupParams } from 'app/operator/operator-signup/signup-params';
import { DomSanitizer } from '@angular/platform-browser';

enum MenuTab {
    Documents = 1,
    Training = 2,
    PersonalDetails = 3,
}

enum MenuProgressTab {
    None = 0,
    DriversLicense = 76,
    ORCR = 77,
    VehiclePhotos = 78,
    NBI = 79,
    PAorCPC = 80,
    PreviousExperience = 81,
    Orientation = 7,
    SkillAssessment = 8,
    ApplicationDetails = 9,
    FitToDrive = 82,
    AuthorizationLetterOrSPA = 83,
    DeedOrCertificateOfSale = 84,
    MedicalExam = 85,
    SssNumber = 86,
    TinNumber = 87,
    PagIbigNumber = 88,
    PhilHealthNumber = 89,
    PoliceClearance = 90,
}

enum DocStatus {
    None = 0,
    ActionRequired = 1,
    Approved = 2,
    Rejected = 3,
}

interface AccordionItem {
    id: number;
    name: string;
    value: MenuProgressTab;
    isActive: boolean;
    header: string;
    status: DocStatus;
    imgUrls: string[];
    newFiles: File[];
    progressTab: MenuProgressTab;
    reviewDecisionTouched?: boolean;
}

@Component({
    selector: 'registration-application-progress-v2',
    templateUrl: './registration-application-progress-v2.component.html',
    styleUrls: ['./registration-application-progress-v2.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ]
})

export class RegistrationApplicationProgressV2Component implements OnInit, OnDestroy {

    public isVisibleRegistrationAppProgressModal: boolean = false;
    @Input()
    set _isVisibleRegistrationAppProgressModal(value: boolean) {
        // Reset the document scroll BEFORE the dialog opens and locks the body.
        // PrimeNG positions overlays appended to body using the document scroll
        // offset; if the page is scrolled, dropdown/calendar overlays end up
        // shifted outside the dialog. The background is hidden by the mask, so
        // resetting here is invisible; the original scroll is restored on close.
        if (value && !this.isVisibleRegistrationAppProgressModal) {
            this.savedScrollX = window.scrollX || window.pageXOffset || 0;
            this.savedScrollY = window.scrollY || window.pageYOffset || 0;
            window.scrollTo(0, 0);
        }
        this.isVisibleRegistrationAppProgressModal = value;
    }

    public riderId!: number;
    @Input()
    set _riderId(value: number) {
        this.riderId = value;
    }

    public riderVehicleId!: number;
    @Input()
    set _riderVehicleId(value: number) {
        this.riderVehicleId = value;
    }

    public xpressUserId!: number;
    @Input()
    set _xpressUserId(value: number) {
        this.xpressUserId = value;
    }

    public riderVehicleServiceTypeId!: number;
    @Input()
    set _riderVehicleServiceTypeId(value: number) {
        this.riderVehicleServiceTypeId = value;
    }

    @Output() changedVisibleRegistrationAppProgressEmit = new EventEmitter<boolean>();
    changedVisibleRegistrationAppProgress(increased: any) {
        this.changedVisibleRegistrationAppProgressEmit.emit(increased);
        this.isVisibleRegistrationAppProgressModal = increased;
    }

    showSaveChangesDialog: boolean = false;
    showConfirmDialog: boolean = false;
    showDenyApplicantDialog: boolean = false;
    confirmModalText: string = '';
    confirmSubText: string = '';
    confirmButtonText: string = '';
    loading: boolean = true;
    isActivation: boolean = false;
    isLocked: boolean = false;

    showGigActivationDialog: boolean = false;
    readonly gigXpressSharePercent: number = 18;
    readonly walletTopUpOptions: { label: string; value: number | null }[] = [
        { label: '₱5,000.00', value: 5000 },
        { label: '₱4,000.00', value: 4000 },
        { label: '₱3,000.00', value: 3000 },
        { label: '₱500.00', value: 500 },
        { label: 'None', value: null },
    ];
    private readonly gigActivationMinLeadMs: number = 60 * 60 * 1000;
    gigWalletTopUpAmount: number | null = null;
    gigActivationDate: string = '';
    gigActivationTime: string = '';
    gigActivationSubmitted: boolean = false;

    denialReasonOptions = DENIAL_REASON_OPTIONS;
    selectedDenialReason: DenialReasonEnum | null = null;
    denialOtherDetails: string = '';
    denialFormSubmitted: boolean = false;
    denialOtherDetailsTouched: boolean = false;
    isDenyingApplication: boolean = false;
    menuTab = MenuTab;
    menuTabActive: MenuTab = MenuTab.Documents;
    menuProgressTab = MenuProgressTab;
    menuProgressTabActive: MenuProgressTab = MenuProgressTab.None;

    fieldTypeEnum = FieldTypeEnum;
    transportationTypeEnum = RiderTransportationTypeEnum;
    scheduleTrainingStatusEnum = ScheduleTrainingStatusEnum;
    serviceType: ServiceTypeEnum = ServiceTypeEnum.None;
    vehicleType: RiderVehicleTypeEnum = RiderVehicleTypeEnum.None;
    transportationTypes = RiderVehicleType.TransportationTypeList;
    serviceTypes = RiderServiceTypeModel.RiderServiceTypeList;
    vehicleTypes = RiderVehicleType.RiderVehicleTypeList.filter(f => f.id !== RiderVehicleTypeEnum.None);

    trainingCenters: any[] = [];
    orientationAttempts: any[] = [];
    skillAssessmentAttempts: any[] = [];
    orientationFailedCount: number = 0;
    skillAssessmentFailedCount: number = 0;
    showTrainingSpinner: boolean = false;
    xpressCenterOptions: any[] = [];
    private readonly allLicenseTypeOptions: any[] = [
        { label: 'Professional', value: XpressDocumentTypeEnum.DriverLicenseProfessional },
        { label: 'Non Professional', value: XpressDocumentTypeEnum.DriverLicenseNonProfessional },
    ];
    public applicationServiceOptions = [
        { label: 'Ride', value: ServiceTypeEnum.Ride },
        { label: 'Taxi', value: ServiceTypeEnum.Taxi },
        { label: 'ConneX', value: ServiceTypeEnum.Connex },
    ];
    public applicationVehicleOptions = [
        { label: '2W', value: RiderTransportationTypeEnum.Moto },
        { label: '4W', value: RiderTransportationTypeEnum.Car },
    ];
    paCpcOptions: any[] = [
        { label: 'PA', value: XpressDocumentTypeEnum.Pa },
        { label: 'CPC', value: XpressDocumentTypeEnum.Cpc },
    ];
    clearanceOptions: any[] = [
        { label: 'NBI Clearance', value: XpressDocumentTypeEnum.NBIClearance },
        { label: 'Police Clearance', value: XpressDocumentTypeEnum.PoliceClearance },
    ];
    docNoImgPath = '/XpressApp/assets/images/doc-no-image.png';
    ridesharingAppOptions: any[] = RidesharingAppModel.RidesharingAppModelList;
    readonly MAX_DOCUMENT_UPLOAD_FILE_SIZE = 10485760; //10Mb

    orientationActiveIndexes: number[] = [];
    skillAssessmentActiveIndexes: number[] = [];
    hasOpenedMenu: boolean = false;
    isSavingChanges: boolean = false;

    trainingMaxDate: Date = (() => {
        const d = new Date();
        d.setHours(23, 59, 59, 999);
        return d;
    })();

    public applicationSourceOptions: any[] = [
        { label: 'Online', value: ApplicationSourceTypeEnum.Online },
        { label: 'Event', value: ApplicationSourceTypeEnum.Event },
        { label: 'Walk-In', value: ApplicationSourceTypeEnum.WalkIn },
    ];
    public ownershipOptions: any[] = [
        { label: 'Owned', value: OwnershipTypeEnum.Owned },
        { label: 'Not Owned', value: OwnershipTypeEnum.NotOwned },
        { label: 'Second Hand', value: OwnershipTypeEnum.SecondHand },
    ];

    public personalDetailsForm: any = {};
    private originalPersonalDetailsForm: string = '';
    private originalRiderInfo: string = '';

    accordionActiveIndex!: number | number[];

    riderInfo: any;
    riderPersonalDetails: any = [];
    serviceAndVehicleDetails: any = [];

    selectedVehicleBrand: number | null = null;
    selectedVehicleModel: number | null = null;
    selectedBrandObj: VehicleBrandModel | null = null;
    selectedModelObj: VehicleModel | null = null;
    brandInputText: string = '';
    modelInputText: string = '';
    vehicleBrands!: VehicleBrandModel[];
    vehicleModels!: VehicleModel[];
    colorTypeList = ColorTypeSelection.ColorTypeList;
    currentYear: number = new Date().getFullYear();
    yearOptions: number[] = [];
    paCpcAccordionItem!: AccordionItem;

    //start galleria
    infoItems: any = [];
    activeImgIndex: number = 0;
    displayImg: boolean = false;
    imageOptions: any[] = [
        {
            breakpoint: '1500px',
            numVisible: 5
        },
        {
            breakpoint: '1024px',
            numVisible: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];
    //end galleria

    constructor(private messageService: MessageService, private riderService: RiderService, private vehicleBrandService: VehicleBrandService,
                private xpressCenterService: XpressCenterService, private sanitizer: DomSanitizer, public appData: AppDataService) {
    }

    public overlayHostEl: HTMLElement | null = null;
    lockHeartBeatInterval: any;
    public readonly filterCharsRegex = /[^\p{Script=Latin}\d\s\-'.,]/gu;
    public readonly allowedCharsRegex = /^(?=.*[\p{Script=Latin}\d])[\p{Script=Latin}\d\s\-'.,]+$/u;

    ngOnInit(): void {
        this.riderInfo = {};
        this.riderInfo.accordionItems = [];
        this.createOverlayHost();
        const years: number[] = [];
        const maxYear = Math.max(this.currentYear, 2030);
        for (let year = maxYear; year >= 1990; year--) {
            years.push(year);
        }
        this.yearOptions = years;

        Promise.all([
            this.getVehicleBrands(),
            this.getVehicleModels()
        ]).then(() => {
            this.getRiderApplicationDetails();
        });

        this.lockHeartBeatInterval = setInterval(() => {
            this.updateRiderDetailsEditLock();
        }, 30000);
    }

    ngOnDestroy(): void {
        if (this.lockHeartBeatInterval) {
            clearInterval(this.lockHeartBeatInterval);
            this.lockHeartBeatInterval = null;
        }
        this.removeRiderDetailsEditLock();

        if (this.overlayHostEl && this.overlayHostEl.parentNode) {
            this.overlayHostEl.parentNode.removeChild(this.overlayHostEl);
        }
        this.overlayHostEl = null;
    }

    // PrimeNG positions overlays (dropdown/calendar) in document coordinates.
    // We append them to a dedicated host attached directly to <body>, anchored to
    // the viewport via position:fixed. Attaching to body avoids transformed layout
    // ancestors (which would otherwise become the containing block and offset the
    // overlay), so the panels align precisely with their fields.
    private createOverlayHost(): void {
        const el = document.createElement('div');
        el.style.position = 'fixed';
        el.style.top = '0';
        el.style.left = '0';
        el.style.width = '0';
        el.style.height = '0';
        el.style.zIndex = '20000';
        document.body.appendChild(el);
        this.overlayHostEl = el;
    }

    getStatus(status: DocStatus) {
        switch (status) {
            case DocStatus.Approved: return 'Approved';
            case DocStatus.ActionRequired: return 'Action Required';
            case DocStatus.Rejected: return 'Rejected';
            default: return '';
        }
    }

    getRiderApplicationDetails() {
        this.loading = true;

        const dto = {
            XpressUserId: this.xpressUserId,
            RiderId: this.riderId,
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId
        };

        this.riderService.getRiderApplicationDetails(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.riderInfo = data;
                const driverLicense = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.DriverLicense ||
                    x.Type === XpressDocumentTypeEnum.DriverLicenseProfessional || x.Type === XpressDocumentTypeEnum.DriverLicenseNonProfessional);

                const orCr = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.OfficialReceiptAndCertificateOfRegistration);

                if (this.riderInfo.OwnershipType === OwnershipTypeEnum.NotOwned) {
                    const alSpa = this.mergeDocumentsByTypePriority(data.Documents, [
                        XpressDocumentTypeEnum.AlOrNotarizedSPA,
                        XpressDocumentTypeEnum.AuthorizationLetter,
                        XpressDocumentTypeEnum.NotarizedSPA
                    ]);

                    this.riderInfo.AlSpaStatus = alSpa ? (alSpa?.Status ?? 1) : null;
                    this.riderInfo.AlSpaImageUrls = alSpa?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                }

                if (this.riderInfo.OwnershipType === OwnershipTypeEnum.SecondHand) {
                    const deedOrCertifOfSale = this.mergeDocumentsByTypePriority(data.Documents, [
                        XpressDocumentTypeEnum.DeedOfSaleOrCertificateOfSale,
                        XpressDocumentTypeEnum.DeedOfSale,
                        XpressDocumentTypeEnum.CertificateOfSale
                    ]);

                    this.riderInfo.DeedOrCertifStatus = deedOrCertifOfSale ? (deedOrCertifOfSale?.Status ?? 1) : null;
                    this.riderInfo.DeedOrCertifImageUrls = deedOrCertifOfSale?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                }

                data.Documents.forEach((doc: any) => {
                    doc?.Files.forEach((file: any) => {
                        if (file.IsPdf) {
                            file.SafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                                file.ImageUrl
                            );
                        }
                    });
                });

                const vehiclePhoto = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.VehiclePhoto);
                const clearance = this.mergeDocumentsByTypePriority(data.Documents, [
                    XpressDocumentTypeEnum.PoliceClearance,
                    XpressDocumentTypeEnum.NBIClearance
                ]);
                const nbi = clearance ?? data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.NBIClearance);
                const paCpc = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.PaOrCpc ||
                    x.Type === XpressDocumentTypeEnum.Pa || x.Type === XpressDocumentTypeEnum.Cpc);
                const previousExperience = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.PreviousAppExperience);
                const fitToDrive = data.Documents.find((x: any) => x.Type === XpressDocumentTypeEnum.FitToDriveCertificate);

                this.riderInfo.DriverLicenseStatus = driverLicense ? (driverLicense?.Status ?? 1) : null;
                this.riderInfo.DriverLicenseImageUrls = driverLicense?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                this.riderInfo.DriverLicenseExpirationDate = data.DriverLicenseExpirationDate ? new Date(data.DriverLicenseExpirationDate) : null;

                this.riderInfo.OrCrStatus = orCr ? (orCr?.Status ?? 1) : null;
                this.riderInfo.OrCrImageUrls = orCr?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                this.riderInfo.OrCrExpirationDate = data.OrCrExpirationDate ? new Date(data.OrCrExpirationDate) : null;

                this.riderInfo.VehiclePhotoStatus = vehiclePhoto ? (vehiclePhoto?.Status ?? 1) : null;
                this.riderInfo.VehiclePhotoImageUrls = vehiclePhoto?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];

                this.riderInfo.NBIStatus = nbi ? (nbi?.Status ?? 1) : null;
                this.riderInfo.NBIImageUrls = nbi?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                this.riderInfo.NbiExpirationDate = data.NbiExpirationDate ? new Date(data.NbiExpirationDate) : null;
                this.riderInfo.ClearanceType = data.ClearanceType
                    ?? (nbi?.Type === XpressDocumentTypeEnum.PoliceClearance || nbi?.Type === XpressDocumentTypeEnum.NBIClearance
                        ? nbi.Type
                        : XpressDocumentTypeEnum.NBIClearance);
                const taxiDocumentFields: any[] = [
                    [XpressDocumentTypeEnum.MedicalExamResults, 'MedicalExam'],
                    [XpressDocumentTypeEnum.SssNumberProof, 'SssNumber'],
                    [XpressDocumentTypeEnum.TinNumberProof, 'TinNumber'],
                    [XpressDocumentTypeEnum.PagIbigNumberProof, 'PagIbigNumber'],
                    [XpressDocumentTypeEnum.PhilHealthNumberProof, 'PhilHealthNumber']
                ];
                taxiDocumentFields.forEach(([type, name]) => {
                    const document = data.Documents.find((x: any) => x.Type === type);
                    this.riderInfo[`${name}Status`] = document?.Status ?? DocStatus.ActionRequired;
                    this.riderInfo[`${name}ImageUrls`] = document?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                });
                this.riderInfo.MedicalExamDate = data.MedicalExamDate ? new Date(data.MedicalExamDate) : null;
                this.riderInfo.SssNumber = data.SssNumber ?? '';
                this.riderInfo.TinNumber = data.TinNumber ?? '';
                this.riderInfo.TinRegisteredName = data.TinRegisteredName ?? '';
                this.riderInfo.PagIbigNumber = data.PagIbigNumber ?? '';
                this.riderInfo.PhilHealthNumber = data.PhilHealthNumber ?? '';

                this.riderInfo.PaCpcStatus = paCpc ? (paCpc?.Status ?? 1) : null;
                this.riderInfo.PaCpcImageUrls = paCpc?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];
                this.riderInfo.PaCpcExpirationDate = data.PaCpcExpirationDate ? new Date(data.PaCpcExpirationDate) : null;

                this.riderInfo.PreviousExperienceStatus = previousExperience ? (previousExperience?.Status ?? 1) : null;
                this.riderInfo.PreviousExperienceImageUrls = previousExperience?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];

                this.riderInfo.FitToDriveStatus = fitToDrive ? (fitToDrive?.Status ?? 1) : null;
                this.riderInfo.FitToDriveImageUrls = fitToDrive?.Files ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}];

                const model = this.vehicleModels.find((m) => m.Id === data.VehicleModelId);
                if (model) {
                    this.selectedModelObj = model;
                    this.selectedVehicleModel = model.Id;
                    this.modelInputText = model.NameModel;
                }
                const brand = this.vehicleBrands.find((b) => b.Id === data.VehicleBrandId);
                if (brand) {
                    this.selectedBrandObj = brand;
                    this.selectedVehicleBrand = brand.Id;
                    this.brandInputText = brand.NameBrand;
                }

                this.riderPersonalDetails = [
                    { title: 'Full Name', value: this.riderInfo.FullName },
                    { title: 'Date of Birth', value: this.riderInfo.DateOfBirth },
                    { title: 'Mobile Number', value: this.riderInfo.MobileNumber },
                    { title: 'Email', value: this.riderInfo.Email },
                    { title: 'Full Address', value: this.riderInfo.FullAddress },
                    { title: 'Emergency Contact Name', value: this.riderInfo.EmergencyContactName },
                    { title: 'Emergency Contact Phone', value: this.riderInfo.EmergencyContactPhone },
                ];
                this.serviceAndVehicleDetails = [
                    { title: 'Vehicle Type', value: this.riderInfo.AllVehicleTypes },
                    { title: 'Service Type', value: this.riderInfo.AllServiceTypes },
                    { title: 'Ownership Status', value: this.riderInfo.OwnershipTypeText },
                    { title: 'Age', value: this.riderInfo.Age },
                    { title: 'Application Status', value: this.riderInfo.ApplicationStatus },
                    { title: 'Last Updated By', value: this.riderInfo.LastUpdatedBy },
                ];

                this.buildPersonalDetailsForm();
                this.getTrainingCentersRider();

                this.riderInfo.markedToRemoveFiles = [];
                this.riderInfo.markedToRemoveFileIds = [];
                this.paCpcAccordionItem = {
                    id: 6,
                    name: 'PA/CPC',
                    value: MenuProgressTab.PAorCPC,
                    isActive: true,
                    header: 'Permit',
                    status: this.riderInfo.PaCpcStatus,
                    imgUrls: this.riderInfo.PaCpcImageUrls,
                    newFiles: [],
                    progressTab: MenuProgressTab.PAorCPC,
                };
                this.getAccordionItems();
                this.originalRiderInfo = JSON.stringify(this.riderInfo);
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    private mergeDocumentsByTypePriority(documents: any[], types: XpressDocumentTypeEnum[]) {
        const matchedDocuments: any[] = [];
        for (const type of types) {
            const typeDocuments = documents.filter((x: any) => x.Type === type);
            if (typeDocuments.length) {
                matchedDocuments.push(...typeDocuments);
            }
        }

        if (!matchedDocuments.length) {
            return null;
        }

        const statuses = matchedDocuments
            .map((document: any) => document.Status)
            .filter((documentStatus: any) => documentStatus != null);
        const status = statuses.includes(DocStatus.Rejected)
            ? DocStatus.Rejected
            : statuses.includes(DocStatus.ActionRequired)
                ? DocStatus.ActionRequired
                : statuses.length
                    ? DocStatus.Approved
                    : DocStatus.ActionRequired;

        return {
            ...matchedDocuments[0],
            Status: status,
            Files: matchedDocuments.reduce((files: any[], document: any) => {
                files.push(...(document.Files ?? []));
                return files;
            }, []),
        };
    }

    private buildPersonalDetailsForm() {
        this.personalDetailsForm = {
            FullName: this.riderInfo.FullName ?? '',
            DateOfBirth: this.riderInfo.BirthDate ? new Date(this.riderInfo.BirthDate) : null,
            Email: this.riderInfo.Email ?? '',
            FullAddress: this.riderInfo.FullAddress ?? '',
            EmergencyContactName: this.riderInfo.EmergencyContactName ?? '',
            EmergencyContactPhone: this.riderInfo.EmergencyContactPhone ?? '',
            OwnershipType: this.riderInfo.OwnershipType ?? null,
            ApplicationSourceType: this.riderInfo.ApplicationSourceType ?? null,
            ServiceTypeId: this.riderInfo.ServiceType ?? null,
            TransportationType: this.riderInfo.TransportationType ?? null,
            IsSalaried: this.riderInfo.IsSalaried ?? false,
            IsEVDriver: this.riderInfo.IsEVDriver ?? false,
        };
        this.personalDetailsTouched = {};
        this.originalPersonalDetailsForm = JSON.stringify(this.serializePersonalDetailsForm());
    }

    private serializePersonalDetailsForm(): any {
        const f = this.personalDetailsForm;
        return {
            FullName: (f.FullName ?? '').trim(),
            DateOfBirth: f.DateOfBirth ? new Date(f.DateOfBirth).getTime() : null,
            Email: (f.Email ?? '').trim(),
            FullAddress: (f.FullAddress ?? '').trim(),
            EmergencyContactName: (f.EmergencyContactName ?? '').trim(),
            EmergencyContactPhone: (f.EmergencyContactPhone ?? '').trim(),
            OwnershipType: f.OwnershipType ?? null,
            ApplicationSourceType: f.ApplicationSourceType ?? null,
            ServiceTypeId: f.ServiceTypeId ?? null,
            TransportationType: f.TransportationType ?? null,
            IsSalaried: !!f.IsSalaried,
            IsEVDriver: !!f.IsEVDriver,
        };
    }

    public get isDocumentsDirty(): boolean {
        const newFilesAdded = this.riderInfo.accordionItems.some((x: AccordionItem) => x.newFiles.length > 0);
        return (JSON.stringify(this.riderInfo) !== this.originalRiderInfo) || newFilesAdded;
    }

    public get isPersonalDetailsDirty(): boolean {
        return JSON.stringify(this.serializePersonalDetailsForm()) !== this.originalPersonalDetailsForm;
    }

    public readonly personalDetailsRequiredFields: string[] = [
        'FullName',
        'DateOfBirth',
        'Email',
        'FullAddress',
        'EmergencyContactName',
        'EmergencyContactPhone',
        'OwnershipType',
        'ApplicationSourceType',
    ];

    public personalDetailsTouched: { [key: string]: boolean } = {};

    public markPersonalFieldTouched(field: string): void {
        this.personalDetailsTouched[field] = true;
    }

    public isPersonalFieldEmpty(field: string): boolean {
        const value = this.personalDetailsForm?.[field];
        if (value === null || value === undefined) {
            return true;
        }
        if (typeof value === 'string') {
            return value.trim().length === 0;
        }
        return false;
    }

    public showPersonalFieldError(field: string): boolean {
        return !!this.personalDetailsTouched[field] && this.isPersonalFieldEmpty(field);
    }

    public get isOrientationCompleted(): boolean {
        return this.getLastSavedTrainingStatus(this.orientationAttempts) === ScheduleTrainingStatusEnum.Passed;
    }

    public get isOrientationFailed(): boolean {
        return this.getLastSavedTrainingStatus(this.orientationAttempts) === ScheduleTrainingStatusEnum.Failed;
    }

    public get isSkillAssessmentCompleted(): boolean {
        return this.getLastSavedTrainingStatus(this.skillAssessmentAttempts) === ScheduleTrainingStatusEnum.Passed;
    }

    public get isSkillAssessmentFailed(): boolean {
        return this.getLastSavedTrainingStatus(this.skillAssessmentAttempts) === ScheduleTrainingStatusEnum.Failed;
    }

    private getLastSavedTrainingStatus(attempts: any[]): ScheduleTrainingStatusEnum | null {
        const saved = (attempts || []).filter((a: any) => a.ScheduleTrainingCenterId > 0);
        if (saved.length === 0) {
            return null;
        }
        return saved[saved.length - 1].ScheduleTrainingStatus;
    }

    public get isApplicationDetailsCompleted(): boolean {
        const r = this.riderInfo;
        if (!r) {
            return false;
        }
        const hasText = (v: any) => typeof v === 'string' ? v.trim().length > 0 : (v !== null && v !== undefined);
        return hasText(r.FullName)
            && r.BirthDate !== null && r.BirthDate !== undefined && r.BirthDate !== ''
            && hasText(r.Email)
            && hasText(r.FullAddress)
            && hasText(r.EmergencyContactName)
            && hasText(r.EmergencyContactPhone)
            && (this.isTaxiLikeService || (r.OwnershipType !== null && r.OwnershipType !== undefined))
            && r.ApplicationSourceType !== null && r.ApplicationSourceType !== undefined
            && r.ServiceType !== null && r.ServiceType !== undefined
            && r.TransportationType !== null && r.TransportationType !== undefined;
    }

    public get isPersonalDetailsValid(): boolean {
        const required = this.isTaxiLikeService
            ? this.personalDetailsRequiredFields.filter(f => f !== 'OwnershipType')
            : this.personalDetailsRequiredFields;
        return required.every(f => !this.isPersonalFieldEmpty(f))
            && this.personalDetailsForm?.ServiceTypeId != null
            && this.personalDetailsForm?.TransportationType != null;
    }

    public get licenseTypeOptions(): any[] {
        if (this.isTaxiLikeService) {
            return this.allLicenseTypeOptions.filter(o => o.value === XpressDocumentTypeEnum.DriverLicenseProfessional);
        }
        return this.allLicenseTypeOptions;
    }

    public get isTaxiLikeService(): boolean {
        // Prefer the in-form path so Earning Type / Vehicle react when Service changes
        // before Save (do not keep using the previously loaded riderInfo.ServiceType).
        const serviceTypeId = this.personalDetailsForm?.ServiceTypeId ?? this.riderInfo?.ServiceType;
        return serviceTypeId === ServiceTypeEnum.Taxi || serviceTypeId === ServiceTypeEnum.Connex;
    }

    public onApplicationServiceChange(): void {
        if (this.personalDetailsForm.ServiceTypeId === ServiceTypeEnum.Taxi || this.personalDetailsForm.ServiceTypeId === ServiceTypeEnum.Connex) {
            this.personalDetailsForm.TransportationType = RiderTransportationTypeEnum.Car;
            this.personalDetailsForm.IsSalaried = true;
            if (this.riderInfo) {
                this.riderInfo.DriverLicenseType = XpressDocumentTypeEnum.DriverLicenseProfessional;
                if (this.riderInfo.ClearanceType !== XpressDocumentTypeEnum.PoliceClearance) {
                    this.riderInfo.ClearanceType = XpressDocumentTypeEnum.NBIClearance;
                }
            }
        } else if (this.personalDetailsForm.ServiceTypeId === ServiceTypeEnum.Ride) {
            // Ride default: non-salaried (toggle becomes editable again).
            this.personalDetailsForm.IsSalaried = false;
        }
    }

    public get isDocumentsMetadataValid(): boolean {
        if (this.isTaxiLikeService) {
            return this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseProfessional
                && !!this.riderInfo.DriverLicenseExpirationDate
                && this.isValidText(this.riderInfo.DriverLicenseNumber)
                && this.isClearanceTypeValid
                && !!this.riderInfo.NbiExpirationDate
                && !!this.riderInfo.MedicalExamDate
                && this.isValidText(this.riderInfo.SssNumber)
                && this.isValidText(this.riderInfo.TinNumber)
                && this.isValidText(this.riderInfo.PagIbigNumber)
                && this.isValidText(this.riderInfo.PhilHealthNumber);
        }
        const is4W = this.riderInfo.TransportationType === RiderTransportationTypeEnum.Car;

        return !!(
            this.riderInfo.DriverLicenseExpirationDate &&
            this.isValidText(this.riderInfo.DriverLicenseNumber) &&
            (
                this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseNonProfessional ||
                this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseProfessional
            ) &&

            this.isValidText(this.riderInfo.OrCrOwnerFirstName) &&
            this.isValidText(this.riderInfo.OrCrOwnerLastName) &&
            this.riderInfo.OrCrExpirationDate &&

            this.isValidText(this.riderInfo.OrCrPlateNumber) &&
            this.isValidText(this.riderInfo.OrCrChassisNumber) &&
            this.isValidText(this.riderInfo.OrCrEngineNumber) &&

            this.riderInfo.TransportationType &&
            this.riderInfo.ServiceType &&
            this.riderInfo.VehicleType &&

            (
                this.selectedVehicleBrand ||
                this.isValidText(this.brandInputText)
            ) &&

            (
                this.selectedVehicleModel ||
                this.isValidText(this.modelInputText)
            ) &&

            this.riderInfo.VehicleYear &&
            this.riderInfo.VehicleColor &&
            this.riderInfo.NbiExpirationDate &&

            (
                !is4W ||
                (
                    (this.riderInfo.PaCpcType === XpressDocumentTypeEnum.Pa ||
                        this.riderInfo.PaCpcType === XpressDocumentTypeEnum.Cpc) &&
                    this.isValidText(this.riderInfo.PaCpcCaseNumber) &&
                    this.isValidText(this.riderInfo.PaCpcOperatorName) &&
                    this.riderInfo.PaCpcExpirationDate
                )
            )
        );
    }

    public get isTinDetailsEncoded(): boolean {
        const hasText = (value: string | null | undefined) => !!value?.trim();
        return hasText(this.riderInfo?.TinNumber)
            && hasText(this.riderInfo?.TinRegisteredName);
    }

    public setDocumentReviewStatus(item: AccordionItem, status: DocStatus): void {
        if (item.value === MenuProgressTab.TinNumber && !this.isTinDetailsEncoded) {
            this.messageService.add({
                severity: 'warn',
                summary: 'TIN details required',
                detail: 'Encode TIN Number and Registered Name before approving or rejecting TIN.'
            });
            return;
        }
        item.status = status;
        item.reviewDecisionTouched = true;
    }

    private isValidText(value: string | null | undefined): boolean {
        if (!value?.trim()) {
            return false;
        }

        return this.allowedCharsRegex.test(value);
    }

    get allDocumentsApproved(): boolean {
        return JSON.parse(this.originalRiderInfo).accordionItems
            .every((x: AccordionItem) => x.status === DocStatus.Approved
                || x.status === DocStatus.None);
    }

    public get computedAge(): number | string {
        const dob = this.personalDetailsForm?.DateOfBirth;
        if (!dob) {
            return this.riderInfo?.Age ?? '';
        }
        const birth = new Date(dob);
        if (isNaN(birth.getTime())) {
            return this.riderInfo?.Age ?? '';
        }
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age < 0 ? 0 : age;
    }

    public getAccordionItems() {
        if (this.isTaxiLikeService) {
            const emptyImg = [{ImageUrl: this.docNoImgPath, IsPdf: false}];
            this.riderInfo.accordionItems = [
                {
                    id: 0,
                    name: 'Professional Driver\'s License',
                    value: MenuProgressTab.DriversLicense,
                    isActive: true,
                    header: 'Identity',
                    status: this.riderInfo.DriverLicenseStatus,
                    imgUrls: this.riderInfo.DriverLicenseImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.DriversLicense,
                },
                {
                    id: 1,
                    name: 'NBI / Police Clearance',
                    value: this.clearanceMenuTab,
                    isActive: true,
                    header: 'Background',
                    status: this.riderInfo.NBIStatus,
                    imgUrls: this.riderInfo.NBIImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: this.clearanceMenuTab,
                },
                {
                    id: 2,
                    name: 'Medical Exam Results',
                    value: MenuProgressTab.MedicalExam,
                    isActive: true,
                    header: 'Medical',
                    status: this.riderInfo.MedicalExamStatus,
                    imgUrls: this.riderInfo.MedicalExamImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.MedicalExam,
                },
                {
                    id: 3,
                    name: 'SSS Number Proof',
                    value: MenuProgressTab.SssNumber,
                    isActive: true,
                    header: 'SSS',
                    status: this.riderInfo.SssNumberStatus,
                    imgUrls: this.riderInfo.SssNumberImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.SssNumber,
                },
                {
                    id: 4,
                    name: 'TIN Number Proof',
                    value: MenuProgressTab.TinNumber,
                    isActive: true,
                    header: 'TIN',
                    status: this.riderInfo.TinNumberStatus,
                    imgUrls: this.riderInfo.TinNumberImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.TinNumber,
                },
                {
                    id: 5,
                    name: 'Pag-IBIG Number Proof',
                    value: MenuProgressTab.PagIbigNumber,
                    isActive: true,
                    header: 'Pag-IBIG',
                    status: this.riderInfo.PagIbigNumberStatus,
                    imgUrls: this.riderInfo.PagIbigNumberImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.PagIbigNumber,
                },
                {
                    id: 6,
                    name: 'PhilHealth Number Proof',
                    value: MenuProgressTab.PhilHealthNumber,
                    isActive: true,
                    header: 'PhilHealth',
                    status: this.riderInfo.PhilHealthNumberStatus,
                    imgUrls: this.riderInfo.PhilHealthNumberImageUrls ?? emptyImg,
                    newFiles: [],
                    progressTab: MenuProgressTab.PhilHealthNumber,
                },
            ];
            return;
        }
        const baseItems: AccordionItem[] = [
            {
                id: 0,
                name: 'Driver\'s License',
                value: MenuProgressTab.DriversLicense,
                isActive: true,
                header: 'Identity',
                status: this.riderInfo.DriverLicenseStatus,
                imgUrls: this.riderInfo.DriverLicenseImageUrls,
                newFiles: [],
                progressTab: MenuProgressTab.DriversLicense,
            },
            {
                id: 8,
                name: 'TIN',
                value: MenuProgressTab.TinNumber,
                isActive: true,
                header: '',
                status: this.riderInfo.TinNumberStatus ?? DocStatus.ActionRequired,
                imgUrls: this.riderInfo.TinNumberImageUrls ?? [{ImageUrl: this.docNoImgPath, IsPdf: false}],
                newFiles: [],
                progressTab: MenuProgressTab.TinNumber,
            },
            {
                id: 1,
                name: 'OR/CR',
                value: MenuProgressTab.ORCR,
                isActive: true,
                header: 'Vehicle',
                status: this.riderInfo.OrCrStatus,
                imgUrls: this.riderInfo.OrCrImageUrls,
                newFiles: [],
                progressTab: MenuProgressTab.ORCR,
            },
        ];

        const ownershipItem = this.buildOwnershipItem();
        if (ownershipItem) {
            baseItems.push(ownershipItem);
        }

        const part2Items: AccordionItem[] = [
            {
                id: 4,
                name: 'Vehicle Photos',
                value: MenuProgressTab.VehiclePhotos,
                isActive: true,
                header: '',
                status: this.riderInfo.VehiclePhotoStatus,
                imgUrls: this.riderInfo.VehiclePhotoImageUrls,
                newFiles: [],
                progressTab: MenuProgressTab.VehiclePhotos,
            },
            {
                id: 5,
                name: 'NBI',
                value: MenuProgressTab.NBI,
                isActive: true,
                header: 'Background',
                status: this.riderInfo.NBIStatus,
                imgUrls: this.riderInfo.NBIImageUrls,
                newFiles: [],
                progressTab: MenuProgressTab.NBI,
            },
        ];

        const part3Items: AccordionItem[] = [];
        if (this.riderInfo.TransportationType === RiderTransportationTypeEnum.Car) {
            part3Items.push(this.paCpcAccordionItem);
        }

        const prevExp: AccordionItem[] = [{
            id: 7,
            name: 'Previous Experience',
            value: MenuProgressTab.PreviousExperience,
            isActive: true,
            header: 'Experience',
            status: this.riderInfo.PreviousExperienceStatus,
            imgUrls: this.riderInfo.PreviousExperienceImageUrls,
            newFiles: [],
            progressTab: MenuProgressTab.PreviousExperience,
        }];

        this.riderInfo.accordionItems = [...baseItems, ...part2Items, ...part3Items, ...prevExp];

        if (!this.riderInfo.IsRiderNotOld) {
            this.riderInfo.accordionItems.push({
                id: 8,
                name: 'Fit To Drive Certificate',
                value: MenuProgressTab.FitToDrive,
                isActive: true,
                header: 'Fit To Drive',
                status: this.riderInfo.FitToDriveStatus,
                imgUrls: this.riderInfo.FitToDriveImageUrls,
                newFiles: [],
                progressTab: MenuProgressTab.FitToDrive,
            });
        }
    }

    accordionActiveIndexChange(index: number | number[]) {
        this.accordionActiveIndex = index;
        if (index !== null) {
            const accordionItem = this.findAccordionItemById(this.accordionActiveIndex);
            this.menuProgressTabActive = accordionItem.value;
        } else {
            this.menuProgressTabActive = MenuProgressTab.None;
        }
    }

    findAccordionItemById(id: number | number[]): any {
        const activeItems = this.riderInfo.accordionItems.filter((item: any) => item.isActive);
        if (Array.isArray(id)) {
            return id.map(i => activeItems[i]).filter(item => item !== undefined);
        } else {
            return activeItems[id] ?? null;
        }
    }

    public async selectProgressTab(menuTab: MenuTab, menuProgressTab: MenuProgressTab) {
        if (this.isCurrentTabDirty && ((this.menuTabActive !== menuTab) ||
            this.menuTabActive === MenuTab.Training && menuTab === MenuTab.Training)) {
            this.showSaveChangesDialog = true;
            return;
        }

        this.accordionActiveIndex = -1;
        this.hasOpenedMenu = true;

        this.menuTabActive = menuTab;
        this.menuProgressTabActive = menuProgressTab;

        const accordionItemindex = this.riderInfo.accordionItems
            .filter((item: any) => item.isActive)
            .findIndex((f: any) => f.value === this.menuProgressTabActive);

        if (accordionItemindex > -1) {
            this.accordionActiveIndexChange(accordionItemindex);
        }

        if (menuTab === MenuTab.Training) {
            await this.getTrainingCentersRider();
        }
    }

    public showVisibleImageModal(url: string, isPdf: boolean) {
        this.infoItems = [{ value: url, isPdf }];
        this.activeImgIndex = 0;
        this.displayImg = true;
    }

    private savedScrollX = 0;
    private savedScrollY = 0;

    cancel() {
        this.changedVisibleRegistrationAppProgress(false);
        window.scrollTo(this.savedScrollX, this.savedScrollY);
    }

    protected readonly DocStatus = DocStatus;

    public getTrainingCentersRider(): Promise<void> {
        this.showTrainingSpinner = true;

        const dto = {
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId
        };

        return this.riderService.getTrainingCentersRider(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.showTrainingSpinner = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.trainingCenters = (data.Items || []).map((x: any) => {
                    x.StartScheduleDate = Utils.utcToLocaleDateString(x.StartSchedule);
                    x.StartScheduleTime = Utils.utcToLocaleTimeString(x.StartSchedule);
                    x.StartScheduleDateTime = x.StartSchedule
                        ? moment.utc(x.StartSchedule).local().format('DD MMM YYYY, HH:mm')
                        : '';
                    x.StartScheduleLocal = x.StartSchedule ? moment.utc(x.StartSchedule).local().toDate() : null;
                    x.IsNew = false;
                    x.PendingScheduleStatus = null;
                    x.OriginalXpressCenterId = x.XpressCenterId;
                    x.OriginalStartScheduleTime = x.StartScheduleLocal ? x.StartScheduleLocal.getTime() : null;
                    return x;
                });

                this.orientationAttempts = this.trainingCenters
                    .filter((x: any) => x.TrainingType === CenterTrainingTypeEnum.ClassroomTraining)
                    .sort((a: any, b: any) => a.ScheduleTrainingCenterId - b.ScheduleTrainingCenterId);
                this.skillAssessmentAttempts = this.trainingCenters
                    .filter((x: any) => x.TrainingType === CenterTrainingTypeEnum.DrivingTraining)
                    .sort((a: any, b: any) => a.ScheduleTrainingCenterId - b.ScheduleTrainingCenterId);

                this.orientationFailedCount = this.orientationAttempts
                    .filter((x: any) => x.ScheduleTrainingStatus === ScheduleTrainingStatusEnum.Failed).length;
                this.skillAssessmentFailedCount = this.skillAssessmentAttempts
                    .filter((x: any) => x.ScheduleTrainingStatus === ScheduleTrainingStatusEnum.Failed).length;

                this.orientationActiveIndexes = [];
                this.skillAssessmentActiveIndexes = [];

                this.getXpressCenters();

                this.showTrainingSpinner = false;
            })
            .catch(err => {
                this.showTrainingSpinner = false;
                throw err;
            });
    }

    public getXpressCenters() {
        if (this.xpressCenterOptions.length > 0) {
            return;
        }

        const dto = {
            SearchName: '',
            City: '',
            Skip: 0,
            Take: 0,
            SortField: '',
            SortOrder: 0
        };

        this.xpressCenterService.getXpressCenters(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    return;
                }
                this.xpressCenterOptions = (data.XpressCenters || []).map((c: any) => ({
                    label: c.Name,
                    value: c.Id
                }));
            })
            .catch(err => {
                console.log(err);
            });
    }

    public addOrientationAttempt() {
        const newAttempt = this.createEmptyAttempt(CenterTrainingTypeEnum.ClassroomTraining);
        this.orientationAttempts = [...this.orientationAttempts, newAttempt];
        this.orientationActiveIndexes = [
            ...this.orientationActiveIndexes,
            this.orientationAttempts.length - 1
        ];
    }

    public addSkillsAssessmentAttempt() {
        const newAttempt = this.createEmptyAttempt(CenterTrainingTypeEnum.DrivingTraining);
        this.skillAssessmentAttempts = [...this.skillAssessmentAttempts, newAttempt];
        this.skillAssessmentActiveIndexes = [
            ...this.skillAssessmentActiveIndexes,
            this.skillAssessmentAttempts.length - 1
        ];
    }

    private createEmptyAttempt(trainingType: CenterTrainingTypeEnum): any {
        return {
            ScheduleTrainingCenterId: 0,
            CenterName: null,
            XpressCenterId: null,
            StartSchedule: null,
            StartScheduleLocal: null,
            StartScheduleDateTime: '',
            ScheduleTrainingStatus: ScheduleTrainingStatusEnum.None,
            PendingScheduleStatus: null,
            TrainingType: trainingType,
            IsNew: true
        };
    }

    public setAttemptStatus(attempt: any, status: ScheduleTrainingStatusEnum) {
        if (attempt.ScheduleTrainingStatus !== ScheduleTrainingStatusEnum.None) {
            return;
        }
        attempt.PendingScheduleStatus = (attempt.PendingScheduleStatus === status) ? null : status;
    }

    public getAttemptDisplayStatus(attempt: any): ScheduleTrainingStatusEnum {
        if (attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Passed
            || attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Failed) {
            return attempt.PendingScheduleStatus;
        }
        return attempt.ScheduleTrainingStatus;
    }

    public get isCurrentTabDirty(): boolean {
        if (this.menuTabActive === MenuTab.Documents) {
            return this.isDocumentsDirty;
        }
        if (this.menuTabActive === MenuTab.Training) {
            const allAttempts = [...this.orientationAttempts, ...this.skillAssessmentAttempts];
            return allAttempts.some((a: any) => this.isAttemptToUpdate(a) || this.isAttemptToAdd(a));
        }
        if (this.menuTabActive === MenuTab.PersonalDetails) {
            return this.isPersonalDetailsDirty;
        }
        return false;
    }

    private isAttemptToAdd(attempt: any): boolean {
        return (!attempt.ScheduleTrainingCenterId || attempt.ScheduleTrainingCenterId === 0)
            && !!attempt.XpressCenterId
            && !!attempt.StartScheduleLocal;
    }

    public isAttemptEditable(attempt: any): boolean {
        return attempt.IsNew || attempt.ScheduleTrainingStatus === ScheduleTrainingStatusEnum.None;
    }

    private isAttemptCenterChanged(attempt: any): boolean {
        return this.isAttemptEditable(attempt)
            && !attempt.IsNew
            && !!attempt.XpressCenterId
            && attempt.XpressCenterId !== attempt.OriginalXpressCenterId;
    }

    private isAttemptStartChanged(attempt: any): boolean {
        if (!this.isAttemptEditable(attempt) || attempt.IsNew || !attempt.StartScheduleLocal) {
            return false;
        }
        const current = new Date(attempt.StartScheduleLocal).getTime();
        return current !== (attempt.OriginalStartScheduleTime ?? null);
    }

    private isAttemptToUpdate(attempt: any): boolean {
        if (!(attempt.ScheduleTrainingCenterId > 0)) {
            return false;
        }
        const hasStatusChange = attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Passed
            || attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Failed;
        return hasStatusChange
            || this.isAttemptCenterChanged(attempt)
            || this.isAttemptStartChanged(attempt);
    }

    public saveChanges() {
        if (this.isSavingChanges) {
            return;
        }

        if (this.menuTabActive === MenuTab.Documents) {
            this.saveDocumentChanges();
        }

        if (this.menuTabActive === MenuTab.Training) {
            this.saveTrainingChanges();
        }

        if (this.menuTabActive === MenuTab.PersonalDetails) {
            this.savePersonalDetailsChanges();
        }
    }

    private async savePersonalDetailsChanges(): Promise<void> {
        if (!this.isPersonalDetailsValid) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Validation',
                detail: 'Please fill in all required fields'
            });
            return;
        }

        this.isSavingChanges = true;

        const dob = this.personalDetailsForm.DateOfBirth;
        const dto = {
            XpressUserId: this.xpressUserId,
            RiderId: this.riderId,
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId,
            FullName: (this.personalDetailsForm.FullName ?? '').trim(),
            DateOfBirth: dob ? moment(dob).format('YYYY-MM-DD') : null,
            Email: (this.personalDetailsForm.Email ?? '').trim(),
            FullAddress: (this.personalDetailsForm.FullAddress ?? '').trim(),
            EmergencyContactName: (this.personalDetailsForm.EmergencyContactName ?? '').trim(),
            EmergencyContactPhone: (this.personalDetailsForm.EmergencyContactPhone ?? '').trim(),
            OwnershipType: this.personalDetailsForm.OwnershipType ?? null,
            ApplicationSourceType: this.personalDetailsForm.ApplicationSourceType,
            ServiceTypeId: this.personalDetailsForm.ServiceTypeId,
            TransportationType: this.personalDetailsForm.TransportationType,
            IsSalaried: this.personalDetailsForm.IsSalaried,
            IsEVDriver: this.personalDetailsForm.IsEVDriver,
        };

        try {
            const result = await this.riderService.updateRiderApplicationDetails(dto, this.messageService);

            if (!result || !result.Success) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: result?.ErrorMessage || 'Failed to save application details'
                });
                return;
            }

            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Application details saved'
            });

            this.getRiderApplicationDetails();
        } finally {
            this.isSavingChanges = false;
        }
    }

    saveDocumentChanges() {
        this.isSavingChanges = true;

        const formData = new FormData();
        this.appendIfExists('DriverLicenseNumber', this.riderInfo.DriverLicenseNumber, formData);
        this.appendIfExists('DriverLicenseType', this.riderInfo.DriverLicenseType, formData);
        this.appendIfExists('OrCrChassisNumber', this.riderInfo.OrCrChassisNumber, formData);
        this.appendIfExists('OrCrEngineNumber', this.riderInfo.OrCrEngineNumber, formData);
        this.appendIfExists('OrCrOwnerFirstName', this.riderInfo.OrCrOwnerFirstName, formData);
        this.appendIfExists('OrCrOwnerLastName', this.riderInfo.OrCrOwnerLastName, formData);
        this.appendIfExists('OrCrPlateNumber', this.riderInfo.OrCrPlateNumber, formData);
        this.appendIfExists('PaCpcType', this.riderInfo.PaCpcType, formData);
        this.appendIfExists('PaCpcCaseNumber', this.riderInfo.PaCpcCaseNumber, formData);
        this.appendIfExists('PaCpcOperatorName', this.riderInfo.PaCpcOperatorName, formData);
        this.appendIfExists('PreviousExperience', this.riderInfo.PreviousExperience, formData);
        this.appendIfExists('RiderId', this.riderId, formData);
        this.appendIfExists('RiderVehicleId', this.riderVehicleId, formData);
        this.appendIfExists('ServiceType', this.riderInfo.ServiceType, formData);
        this.appendIfExists('TransportationType', this.riderInfo.TransportationType, formData);
        this.appendIfExists('VehicleBrandId', this.selectedVehicleBrand, formData);
        this.appendIfExists('VehicleBrandName', this.brandInputText, formData);
        this.appendIfExists('VehicleColor', this.riderInfo.VehicleColor, formData);
        this.appendIfExists('VehicleModelId', this.selectedVehicleModel, formData);
        this.appendIfExists('VehicleModelName', this.modelInputText, formData);
        this.appendIfExists('VehicleType', this.riderInfo.VehicleType, formData);
        this.appendIfExists('VehicleYear', this.riderInfo.VehicleYear, formData);
        this.appendIfExists('XpressUserId', this.xpressUserId, formData);
        this.appendIfExists('RidesharingAppId', this.riderInfo.RidesharingAppId, formData);

        this.appendIfExists('DriverLicenseExpirationDate', this.riderInfo.DriverLicenseExpirationDate
            ? moment(this.riderInfo.DriverLicenseExpirationDate).format('YYYY-MM-DD')
            : null, formData);
        this.appendIfExists('NbiExpirationDate', this.riderInfo.NbiExpirationDate
            ? moment(this.riderInfo.NbiExpirationDate).format('YYYY-MM-DD')
            : null, formData);
        this.appendIfExists('ClearanceType', this.isTaxiLikeService
            ? (this.riderInfo.ClearanceType ?? XpressDocumentTypeEnum.NBIClearance)
            : XpressDocumentTypeEnum.NBIClearance, formData);
        this.appendIfExists('OrCrExpirationDate', this.riderInfo.OrCrExpirationDate
            ? moment(this.riderInfo.OrCrExpirationDate).format('YYYY-MM-DD')
            : null, formData);
        this.appendIfExists('PaCpcExpirationDate', this.riderInfo.PaCpcExpirationDate
            ? moment(this.riderInfo.PaCpcExpirationDate).format('YYYY-MM-DD')
            : null, formData);
        this.appendIfExists('MedicalExamDate', this.riderInfo.MedicalExamDate
            ? moment(this.riderInfo.MedicalExamDate).format('YYYY-MM-DD')
            : null, formData);
        this.appendIfExists('SssNumber', this.riderInfo.SssNumber, formData);
        this.appendIfExists('TinNumber', this.riderInfo.TinNumber, formData);
        this.appendIfExists('TinRegisteredName', this.riderInfo.TinRegisteredName, formData);
        this.appendIfExists('PagIbigNumber', this.riderInfo.PagIbigNumber, formData);
        this.appendIfExists('PhilHealthNumber', this.riderInfo.PhilHealthNumber, formData);

        const documentUpdates = this.riderInfo.accordionItems
            .filter((x: any) => x.value)
            .filter((x: any) => x.value !== MenuProgressTab.TinNumber || x.reviewDecisionTouched)
            .map((x: any) => ({
                DocumentType: x.value,
                DocumentStatus: x.status ?? 0,
                DocumentFiles: x.newFiles
            }));

        documentUpdates.forEach((doc: any, index: number) => {
            this.appendIfExists(`DocumentUpdates[${index}].DocumentType`, doc.DocumentType, formData);
            this.appendIfExists(`DocumentUpdates[${index}].DocumentStatus`, doc.DocumentStatus, formData);

            doc.DocumentFiles?.forEach((file: File) => {
                this.appendIfExists(`DocumentUpdates[${index}].DocumentFiles`, file, formData);
            });
        });

        this.riderInfo.markedToRemoveFiles?.forEach((file: any, index: number) => {
            this.appendIfExists(`FilesToRemove[${index}]`, file, formData);
        });
        this.riderInfo.markedToRemoveFileIds?.forEach((fileId: any, index: number) => {
            this.appendIfExists(`FileIdsToRemove[${index}]`, fileId, formData);
        });

        this.riderService.updateRiderInfoV2(formData, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    this.isSavingChanges = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                if (data.ErrorMessage) {
                    this.messageService.add({ severity: 'warn', summary: 'Partial Success', detail: data.ErrorMessage });
                } else {
                    this.cancel();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully updated.' });
                }

                this.isSavingChanges = false;
                this.getRiderApplicationDetails();
            })
            .catch(err => {
                this.isSavingChanges = false;
                throw err;
            });
    }

    private buildOwnershipItem(): AccordionItem | null {
        switch (this.riderInfo.OwnershipType) {
            case OwnershipTypeEnum.NotOwned:
                return {
                    id: 2,
                    name: 'Authorization Letter or Notarized SPA',
                    value: MenuProgressTab.AuthorizationLetterOrSPA,
                    isActive: true,
                    header: '',
                    status: this.riderInfo.AlSpaStatus,
                    imgUrls: this.riderInfo.AlSpaImageUrls,
                    newFiles: [],
                    progressTab: MenuProgressTab.AuthorizationLetterOrSPA,
                };
            case OwnershipTypeEnum.SecondHand:
                return {
                    id: 3,
                    name: 'Transfer proof: Deed of Sale or Certificate of Sale',
                    value: MenuProgressTab.DeedOrCertificateOfSale,
                    isActive: true,
                    header: '',
                    status: this.riderInfo.DeedOrCertifStatus,
                    imgUrls: this.riderInfo.DeedOrCertifImageUrls,
                    newFiles: [],
                    progressTab: MenuProgressTab.DeedOrCertificateOfSale,
                };
            default:
                return null;
        }
    }

    public getDisplayStatus(item: AccordionItem): DocStatus {
        if (item.value === MenuProgressTab.ORCR) {
            return this.vehicleDisplayStatus;
        }

        return item.status;
    }

    get vehicleDisplayStatus(): DocStatus {
        const items = this.riderInfo?.accordionItems as AccordionItem[];
        if (!items) {
            return DocStatus.ActionRequired;
        }

        const vehicleValues = new Set([
            MenuProgressTab.ORCR,
            MenuProgressTab.VehiclePhotos,
            MenuProgressTab.AuthorizationLetterOrSPA,
            MenuProgressTab.DeedOrCertificateOfSale,
        ]);

        const relevantItems = items.filter(i => vehicleValues.has(i.value));
        const relevantStatuses = relevantItems.map(i => i.status).filter(s => s != null);

        if (relevantStatuses.length === 0) {
            return DocStatus.ActionRequired;
        }

        if (relevantStatuses.every(s => s === DocStatus.Approved)) {
            return DocStatus.Approved;
        }
        if (relevantStatuses.some(s => s === DocStatus.Rejected)) {
            return DocStatus.Rejected;
        }
        return DocStatus.ActionRequired;
    }

    public setRiderStatus(riderStatus: XpressRiderStatus, successMessage?: string) {
        this.isSavingChanges = true;
        const dto = {
            RiderId: this.riderId,
            RiderStatus: riderStatus
        };
        this.riderService.setRiderStatus(dto, this.messageService)
            .then(data => {
                this.isSavingChanges = false;

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.cancel();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: successMessage ?? 'Successfully updated.'
                });
            })
            .catch(err => {
                this.isSavingChanges = false;
                throw err;
            });
    }

    public get isGigActivation(): boolean {
        return this.riderInfo?.ServiceType === ServiceTypeEnum.Ride
            && !this.riderInfo?.IsSalaried
            && [RiderVehicleTypeEnum.Moto, RiderVehicleTypeEnum.Sedan, RiderVehicleTypeEnum.SUV].includes(this.riderInfo?.VehicleType);
    }

    public get activateButtonLabel(): string {
        return this.isGigActivation ? 'Activate Application' : 'Activate Application Now';
    }

    public get gigActivationMinDate(): string {
        return moment().format('YYYY-MM-DD');
    }

    private get gigActivationDateTime(): Date | null {
        if (!this.gigActivationDate || !this.gigActivationTime) {
            return null;
        }
        const parsed = moment(`${this.gigActivationDate}T${this.gigActivationTime}`, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss'], true);
        return parsed.isValid() ? parsed.toDate() : null;
    }

    public get isGigActivationDateTimeValid(): boolean {
        const dateTime = this.gigActivationDateTime;
        if (!dateTime) {
            return false;
        }
        // The time input has no seconds. Compare whole minutes so 12:00 is one hour ahead while the clock still shows 11:00.
        const selectedMinute = moment(dateTime).startOf('minute').valueOf();
        const currentMinute = moment().startOf('minute').valueOf();
        return selectedMinute - currentMinute >= this.gigActivationMinLeadMs;
    }

    public get showGigActivationDateTimeError(): boolean {
        const isFilled = !!this.gigActivationDate && !!this.gigActivationTime;
        return (this.gigActivationSubmitted || isFilled) && !this.isGigActivationDateTimeValid;
    }

    openGigActivationDialog() {
        this.gigWalletTopUpAmount = null;
        this.gigActivationDate = '';
        this.gigActivationTime = '';
        this.gigActivationSubmitted = false;
        this.showGigActivationDialog = true;
    }

    closeGigActivationDialog() {
        this.showGigActivationDialog = false;
    }

    proceedGigActivation() {
        this.gigActivationSubmitted = true;
        const activationDateTime = this.gigActivationDateTime;
        if (!activationDateTime || !this.isGigActivationDateTimeValid) {
            return;
        }

        this.activateRider({
            ActivationDate: moment(activationDateTime).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
            WalletTopUpAmount: this.gigWalletTopUpAmount,
            XpressSharePercent: this.gigXpressSharePercent,
        });
    }

    showActivateModal() {
        if (this.isGigActivation) {
            this.openGigActivationDialog();
            return;
        }

        this.confirmModalText = 'Activate Now ?';
        this.confirmSubText = 'Are you sure you want to activate this driver now ? ' +
            'This will remove the applicant from the Registration flow.';
        this.confirmButtonText = 'Yes, Activate';
        this.showConfirmDialog = true;
    }

    showConfirmModal() {
        this.confirmModalText = 'Put Application On Hold ?';
        this.confirmButtonText = 'Yes, Put On Hold';
        this.confirmSubText = '';
        this.showConfirmDialog = true;
    }

    closeConfirmModal() {
        this.setRiderStatus(XpressRiderStatus.OnHold);
        this.showConfirmDialog = false;
    }


    openDenyApplicantDialog() {
        this.resetDenyApplicantForm();
        this.showDenyApplicantDialog = true;
    }

    closeDenyApplicantDialog() {
        this.showDenyApplicantDialog = false;
        this.resetDenyApplicantForm();
    }

    private resetDenyApplicantForm() {
        this.selectedDenialReason = null;
        this.denialOtherDetails = '';
        this.denialFormSubmitted = false;
        this.denialOtherDetailsTouched = false;
    }

    onDenialReasonChange() {
        if (this.selectedDenialReason !== DenialReasonEnum.Other) {
            this.denialOtherDetails = '';
            this.denialOtherDetailsTouched = false;
        }
    }

    onDenialOtherDetailsChange() {
        this.denialOtherDetailsTouched = true;
    }

    public get isDenialOtherSelected(): boolean {
        return this.selectedDenialReason === DenialReasonEnum.Other;
    }

    public get showDenialReasonError(): boolean {
        return this.denialFormSubmitted && (this.selectedDenialReason === null || this.selectedDenialReason === DenialReasonEnum.None);
    }

    public get showDenialOtherDetailsError(): boolean {
        return this.isDenialOtherSelected
            && (this.denialFormSubmitted || this.denialOtherDetailsTouched)
            && !this.denialOtherDetails?.trim();
    }

    private getDenialReasonLabel(): string {
        const option = this.denialReasonOptions.find(o => o.value === this.selectedDenialReason);
        return option?.label ?? '';
    }

    public get isConfirmDenialDisabled(): boolean {
        if (this.isDenyingApplication) {
            return true;
        }
        if (this.selectedDenialReason === null || this.selectedDenialReason === DenialReasonEnum.None) {
            return true;
        }
        if (this.isDenialOtherSelected && !this.denialOtherDetails?.trim()) {
            return true;
        }
        return false;
    }

    private isDenyFormValid(): boolean {
        if (this.selectedDenialReason === null || this.selectedDenialReason === DenialReasonEnum.None) {
            return false;
        }
        if (this.isDenialOtherSelected && !this.denialOtherDetails?.trim()) {
            return false;
        }
        return true;
    }

    confirmDenial() {
        this.denialFormSubmitted = true;

        if (!this.isDenyFormValid() || this.isDenyingApplication) {
            return;
        }

        const rejectReason = this.getDenialReasonLabel();
        const additionalNotes = this.denialOtherDetails?.trim() || undefined;

        this.isDenyingApplication = true;

        const dto = {
            RiderId: this.riderId,
            RejectReason: rejectReason,
            AdditionalNotes: additionalNotes,
            CreatedByUserId: this.appData.authData?.UserId,
            ServiceType: this.riderInfo?.ServiceType,
            VehicleType: this.riderInfo?.VehicleType,
            IsTerminalDenial: true,
        };

        this.riderService.saveRiderRejectReason(dto, this.messageService)
            .then(data => {
                if (!data?.Success) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: data?.ErrorMessage || 'Failed to deny application'
                    });
                    return;
                }

                this.closeDenyApplicantDialog();
                this.cancel();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Application denied successfully.'
                });
            })
            .catch(err => {
                console.error(err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Unexpected error occurred'
                });
            })
            .finally(() => {
                this.isDenyingApplication = false;
            });
    }
    private async saveTrainingChanges(): Promise<void> {
        const allAttempts = [...this.orientationAttempts, ...this.skillAssessmentAttempts];
        const toSave = allAttempts.filter((a: any) => this.isAttemptToAdd(a) || this.isAttemptToUpdate(a));

        if (toSave.length === 0) {
            return;
        }

        this.isSavingChanges = true;

        let firstFailure: any = null;

        try {
            for (const attempt of toSave) {
                const dto = this.buildAddOrUpdateScheduleTrainingDto(attempt);
                const result = await this.riderService.addOrUpdateScheduleTraining(dto, this.messageService);

                if (!result || !result.Success) {
                    firstFailure = result;
                    break;
                }
            }

            if (firstFailure) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: firstFailure.ErrorMessage || 'Failed to save some training attempts'
                });
            } else {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Training changes saved'
                });
            }

            await this.getTrainingCentersRider();
        } finally {
            this.isSavingChanges = false;
        }
    }

    private buildAddOrUpdateScheduleTrainingDto(attempt: any): any {
        const isNew = this.isAttemptToAdd(attempt);
        const hasStatus = attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Passed
            || attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Failed;
        const isPassed = attempt.PendingScheduleStatus === ScheduleTrainingStatusEnum.Passed;

        let centerId = attempt.XpressCenterId ?? 0;
        let startSchedule = attempt.StartScheduleLocal;

        // For an existing attempt send only the fields the user actually changed
        // so the backend doesn't overwrite the stored center/date with stale values.
        // This applies even when a status update (Pass/Fail) is sent in the same save:
        // confirming pass/fail without touching the calendar must not persist a new
        // StartSchedule (e.g. a value shifted by the timezone adjustment on load).
        if (!isNew) {
            centerId = this.isAttemptCenterChanged(attempt) ? attempt.XpressCenterId : 0;
            startSchedule = this.isAttemptStartChanged(attempt) ? attempt.StartScheduleLocal : null;
        }

        return {
            ScheduleTrainingCenterId: isNew ? 0 : attempt.ScheduleTrainingCenterId,
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId,
            CenterId: centerId ?? 0,
            StartSchedule: startSchedule,
            TrainingType: attempt.TrainingType,
            ScheduleTrainingStatus: hasStatus
                ? attempt.PendingScheduleStatus
                : ScheduleTrainingStatusEnum.None,
            TrainingStatus: hasStatus
                ? (isPassed ? TrainingStatusEnum.PassedTraining : TrainingStatusEnum.FailedTraining)
                : TrainingStatusEnum.None,
            VehicleStatus: hasStatus
                ? (isPassed ? VehicleStatusEnum.Activation : VehicleStatusEnum.Training)
                : VehicleStatusEnum.None
        };
    }

    private getVehicleBrands(): Promise<void> {
        const dto = {
            VehicleType: null,
        };

        return this.vehicleBrandService.getVehicleBrands(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    return;
                }

                this.vehicleBrands = VehicleBrandModel.mapToVehicleBrandModels(data.Items);
            });
    }

    private getVehicleModels(): Promise<void> {
        const dto = {
            VehicleBrandId: null,
            VehicleType: null
        };

        return this.vehicleBrandService.getVehicleModels(dto, this.messageService)
            .then(data => {
                if (!data || !data.Success) {
                    return;
                }

                this.vehicleModels = VehicleModel.mapToVehicleModels(data.Items);
            });
    }

    async onBrandDropdownChange(event: DropdownChangeEvent) {
        if (event.value && typeof event.value === 'object') {
            this.selectedVehicleBrand = event.value.Id;
            this.brandInputText = event.value.NameBrand;
        } else if (typeof event.value === 'string') {
            this.selectedVehicleBrand = null;
            this.brandInputText =  event.value;
        }
    }

    onModelDropdownChange(event: DropdownChangeEvent) {
        if (event.value && typeof event.value === 'object') {
            this.selectedVehicleModel = event.value.Id;
            this.modelInputText = event.value.NameModel;
        } else if (typeof event.value === 'string') {
            this.selectedVehicleModel = null;
            this.modelInputText = event.value;
        }
    }

    deleteDocImage(docFile: any) {
        const fileId = docFile?.FileId;
        if (fileId) {
            const existsById = this.riderInfo.markedToRemoveFileIds.includes(fileId);
            if (existsById) {
                this.riderInfo.markedToRemoveFileIds.splice(this.riderInfo.markedToRemoveFileIds.indexOf(fileId), 1);
            } else {
                this.riderInfo.markedToRemoveFileIds.push(fileId);
            }
            return;
        }

        const imgUrl = docFile?.ImageUrl;
        const exist = this.riderInfo.markedToRemoveFiles.includes(imgUrl);
        if (exist) {
            this.riderInfo.markedToRemoveFiles.splice(this.riderInfo.markedToRemoveFiles.indexOf(imgUrl), 1);
        } else {
            this.riderInfo.markedToRemoveFiles.push(imgUrl);
        }
    }

    isDocImageMarkedToRemove(docFile: any) {
        return docFile?.FileId
            ? this.riderInfo.markedToRemoveFileIds.includes(docFile.FileId)
            : this.riderInfo.markedToRemoveFiles.includes(docFile?.ImageUrl);
    }

    get applicationNotReady() {
        return !this.allDocumentsApproved ||
            !this.isDocumentsMetadataValid ||
            !this.isOrientationCompleted ||
            (!this.isSkillAssessmentCompleted && this.riderInfo.TransportationType === RiderTransportationTypeEnum.Moto) ||
            !this.isPersonalDetailsValid;
    }

    activateRider(gigActivation?: { ActivationDate: string; WalletTopUpAmount: number | null; XpressSharePercent: number }) {
        this.isActivation = true;
        const dto = {
            RiderVehicleServiceTypeId: this.riderVehicleServiceTypeId,
            ActivationDate: moment(new Date()).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
            ...gigActivation,
        };

        this.confirmSubText = '';
        this.showConfirmDialog = false;
        this.riderService.activateRider(dto, this.messageService)
            .then(data => {
                this.isActivation = false;

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.showGigActivationDialog = false;
                this.riderInfo.RiderStatus = XpressRiderStatus.RegistrationCompleted;
                this.riderInfo.VehicleStatus = XpressVehicleStatus.Approved;
                this.cancel();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Activated successfully !' });
            })
            .catch(err => {
                this.isActivation = false;
                throw err;
            });
    }

    onFileDropped($event: any, docType: MenuProgressTab) {
        this.prepareFiles($event, docType);
    }

    fileBrowseHandler(files: any, docType: MenuProgressTab) {
        this.prepareFiles(files, docType);
    }

    prepareFiles(files: any, docType: MenuProgressTab) {
        let filesArr: any[];

        filesArr = files?.target?.files ? Array.from(files.target.files) : Array.from(files);
        filesArr = filesArr.filter((uploadedFile: File) => SignupParams.ACCEPTED_FILE_TYPES.includes(uploadedFile.type));
        filesArr = filesArr.filter((uploadedFile: File) => uploadedFile.size <= this.MAX_DOCUMENT_UPLOAD_FILE_SIZE);
        filesArr = filesArr.slice(0, SignupParams.MAX_UPLOAD_FILES_COUNT);

        const document = this.riderInfo.accordionItems.find((x: AccordionItem) => x.value === docType);
        if (document) {
            document.newFiles = filesArr;
        }
    }

    appendIfExists(key: string, value: any, formData: FormData)  {
        if (value != null) {
            formData.append(key, value);
        }

        return formData;
    }

    get isLicenseTypeValid() {
        if (this.isTaxiLikeService) {
            return this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseProfessional;
        }
        return this.riderInfo.DriverLicenseType && (this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseProfessional ||
            this.riderInfo.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseNonProfessional);
    }

    get isPaCpcTypeValid() {
        return this.riderInfo.PaCpcType && (this.riderInfo.PaCpcType === XpressDocumentTypeEnum.Pa ||
            this.riderInfo.PaCpcType === XpressDocumentTypeEnum.Cpc);
    }

    get isClearanceTypeValid() {
        return this.riderInfo?.ClearanceType === XpressDocumentTypeEnum.NBIClearance
            || this.riderInfo?.ClearanceType === XpressDocumentTypeEnum.PoliceClearance;
    }

    get clearanceMenuTab(): MenuProgressTab {
        return this.riderInfo?.ClearanceType === XpressDocumentTypeEnum.PoliceClearance
            ? MenuProgressTab.PoliceClearance
            : MenuProgressTab.NBI;
    }

    onClearanceTypeChange(): void {
        if (!this.riderInfo?.accordionItems) {
            return;
        }
        const item = this.riderInfo.accordionItems.find((x: AccordionItem) =>
            x.value === MenuProgressTab.NBI || x.value === MenuProgressTab.PoliceClearance
            || x.progressTab === MenuProgressTab.NBI || x.progressTab === MenuProgressTab.PoliceClearance);
        if (!item) {
            return;
        }
        const tab = this.clearanceMenuTab;
        item.value = tab;
        item.progressTab = tab;
        item.name = 'NBI / Police Clearance';
        // Switching clearance type requires re-approval against the matching check.
        if (item.status === DocStatus.Approved) {
            item.status = DocStatus.ActionRequired;
        }
        if (this.menuProgressTabActive === MenuProgressTab.NBI
            || this.menuProgressTabActive === MenuProgressTab.PoliceClearance) {
            this.menuProgressTabActive = tab;
        }
    }

    isClearanceProgressTab(tab: MenuProgressTab): boolean {
        return tab === MenuProgressTab.NBI || tab === MenuProgressTab.PoliceClearance;
    }

    filterLatinInput(event: Event, sourceObj: any, field: string): void {
        const input = event.target as HTMLInputElement;
        const filtered = input.value.replace(this.filterCharsRegex, '');
        input.value = filtered;
        sourceObj[field] = filtered;
    }

    updateRiderDetailsEditLock() {
        const dto = {
            Id: this.riderId,
        };

        this.riderService.updateRiderDetailsEditLock(dto, this.messageService)
            .then(data => {
            })
            .catch(err => {
                throw err;
            });
    }

    removeRiderDetailsEditLock() {
        const dto = {
            Id: this.riderId,
        };

        this.riderService.removeRiderDetailsEditLock(dto, this.messageService)
            .then(data => {
            })
            .catch(err => {
                throw err;
            });
    }

    onTransportationChange(ev: any) {
        const transpType = ev.value;
        const paCpcItem = this.riderInfo.accordionItems.find((x: AccordionItem) => x.value === MenuProgressTab.PAorCPC);
        if (transpType === RiderTransportationTypeEnum.Moto) {
            if (paCpcItem) {
                this.riderInfo.accordionItems.splice(this.riderInfo.accordionItems.indexOf(paCpcItem), 1);
            }
        } else if (transpType === RiderTransportationTypeEnum.Car) {
            if (!paCpcItem) {
                const nbiItem = this.riderInfo.accordionItems.find((x: AccordionItem) => x.value === MenuProgressTab.NBI);
                this.riderInfo.accordionItems.splice(this.riderInfo.accordionItems.indexOf(nbiItem), 0, this.paCpcAccordionItem);
            }
        }
    }

    protected readonly XpressRiderStatus = XpressRiderStatus;
    protected readonly XpressVehicleStatus = XpressVehicleStatus;
}
